import { ReportContentColumnar } from './ReportContentColumnar';
import { ReportContentTableau } from './ReportContentTableau';

export { ReportContentColumnar, ReportContentTableau };

export const LEGACY_TABLEAU_SERVER_URL = 'tableau.powerreviews.com';
